import React,{ useState, useEffect,useRef } from 'react'
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { deleteCategory, getAllCategories, createCategory, editCategory } from '../../api/axiosCategories';
import { getAllBroadCategories } from '../../api/axiosBroadCategories';
import { Toast } from 'primereact/toast';
import { AllToasts } from '../../components/Toasts/AllToasts';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';  
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import DataContext from '../../context/DataContext';
import DeleteDialog from '../../components/dialogs/DeleteDialog';
import { Dialog } from 'primereact/dialog';
import TableActions from '../../components/buttonActions/TableActions';
import SearchToolBar from '../../components/buttonActions/SearchToolBar';





const Categories = () => {
  const { broadCategories, setBroadCategories,categories, setCategories, setFetcherror } = useContext(DataContext);
 
  const toast = useRef(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate()


  const [addItemeDialogVisible, setAddItemDialogVisible] = useState(false);
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  
  const [selectedId, setSelectedId] = useState(); //Track Id for Deleting or Editing
  const [selectedBroadCategory, setSelectedBroadCategory] = useState("");
  
  const [category, setCategory] = useState("");
  const [editedCategory, setEditedCategory] = useState("");
  


 

  const NewTitle = "All Categories";
  useEffect(() => {
    
    getAllCategories(setCategories, setFetcherror);
    getAllBroadCategories(setBroadCategories, setFetcherror);
    
  }, []);

  // Create New Array of Categories with BroadCategories.
  const newcategoriesArray = categories.map((item) => {
    const result = broadCategories.find((itemb) => itemb.id === item.broadcategory_id);
    return { ...item, broadcategory: result ? result.name : null };
  });
  




   

  const filteredCategories = newcategoriesArray.filter((item) => item.name.toLowerCase().includes(globalFilter.toLowerCase()) || item.broadcategory.toLowerCase().includes(globalFilter.toLowerCase()))
  const filteredReversedCategories = filteredCategories.reverse();
  
  const handleAllToasts = (statusNum, msg) => {
    AllToasts(statusNum, msg, toast);
  };

  // Delete Dialogue
  const deletefunction = (pkid, setCategories, setFetcherror, handleAllToasts) => {
    return () => {
      deleteCategory(pkid, setCategories, setFetcherror, handleAllToasts);
    };
  };
  const deletedialogHeader = "Confirm Delete";
  const deletedialogContents = (
      <p>Do you really want to delete this Category?, Click "Yes" to Proceed or "No" to Cancel</p>
  );

  const getItemtoEdit = (pkid, items) => {
    const foundItem = items.find((item) => item.id === pkid);
    setEditedCategory(foundItem?.name);
   
  }



  
  return (

    
    <div className="card">
      <Toast ref={toast} />
      
      <Card title={ NewTitle}>
        <SearchToolBar
          setAddItemDialogVisible={setAddItemDialogVisible}
          globalFilter={globalFilter}
          setGlobalFilter={setGlobalFilter}
          searchPlaceholder="Categories"
          createLabel="Category"
        />
        
        <DataTable
            value={filteredCategories}
            showGridlines
            paginator
            rows={10}
            rowsPerPageOptions={[5, 10, 20, 50, 100, 200, 500]}
            emptyMessage="No categories found"
        >
                    <Column header="S/N" body={(rowData) => newcategoriesArray.indexOf(rowData)+1 } sortable> </Column>
                    <Column header="BroadCategory" body={(rowData) => rowData.broadcategory } sortable></Column>
                    <Column header="Category"   body={(rowData) => rowData.name} sortable></Column>
                    <Column header="Actions" body={(rowData) => (  
                                  <TableActions
                                    id={rowData.id}
                                    data={categories}
                                    getItemtoEdit={getItemtoEdit}
                                    setSelectedId={setSelectedId}
                                    setEditDialogVisible={setEditDialogVisible}
                                    setDeleteDialogVisible={ setDeleteDialogVisible}
                                  />
                          )}>
                    </Column>
        </DataTable>

      
        
        {addItemeDialogVisible &&
          
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="New Category" visible={addItemeDialogVisible} style={{ width: '25vw' }} onHide={() => setAddItemDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                createCategory(category,selectedBroadCategory?.id, setCategory, setFetcherror, handleAllToasts, setCategories);
                if (category ) { setAddItemDialogVisible(false); }
              }}>
                   <label htmlFor="phoneReporter" className="block text-900 font-medium mb-2">Broad Category </label>
                  <Dropdown
                   value={selectedBroadCategory} onChange={(e) => setSelectedBroadCategory(e.value)}
                   options={broadCategories} optionLabel="name"
                  placeholder="-- Select BroadCategory --" showClear className="w-full mb-4"
                  />
                

                  <label htmlFor="phoneReporter" className="block text-900 font-medium mb-2">Category </label>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    placeholder="Enter Category Name"
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                  />

                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setAddItemDialogVisible(false); setCategory("");  }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }
        



        {
          editDialogVisible &&
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="Edit Category" visible={editDialogVisible} style={{ width: '25vw' }} onHide={() => setEditDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                editCategory( selectedId, editedCategory, setEditedCategory,  setFetcherror, handleAllToasts, setCategories);
                if (editedCategory) { setEditDialogVisible(false); }
              }}>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    // disabled
                    placeholder="Enter Category Name"
                    value={editedCategory}
                    onChange={(e) => setEditedCategory(e.target.value)}
                  />

                  
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setEditDialogVisible(false); setCategory("");  }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }

        
        
        {
                deleteDialogVisible &&
        
                <DeleteDialog
                    dilogvisible={deleteDialogVisible}
                    setDilogvisibleVisible={setDeleteDialogVisible}
                    deletefucton={deletefunction(selectedId, setCategories, setFetcherror, handleAllToasts)}
                    dialogHeader={deletedialogHeader}
                    dialogContents={ deletedialogContents}
                    
                 />
      } 
       
                
      </Card>
      
    </div>
  )
}

export default Categories


